export enum OrgTitles {
  CREATE = 'Add New Organization',
  EDIT = 'Edit Organization Details',
  VIEW = 'View Organization Details',
  MANAGE_ORG = 'Manage Organisations',
  ADD_CONTACT = 'Add Contact to Organization',
  EDIT_CONTACT = 'Edit Contact Details',
  VIEW_CONTACT = 'View Contact Details',
  LOCAL_ADMNISTRATOR = 'Local Administrators',
}

export enum OrgMode {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
  ADD_CONTACT = 'Add Contact',
  EDIT_CONTACT = 'Edit Contact',
  VIEW_CONTACT = 'View Contact',
}

export enum OrgStatus {
  ACTIVE = 'Active',
  EXPIRED = 'Expired',
  INACTIVE = 'Inactive',
}
